var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`av-${_vm.lang}`,attrs:{"id":"app"}},[(_vm.pageLoading)?_c('loading'):_vm._e(),(_vm.isRouterAlive && !_vm.pageLoading)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }